<template>
    <div>
      <el-row>
        <el-col>
            <el-date-picker v-model="dateRange" class="filter-item" type="month" placeholder="選擇月" format="yyyy-MM" />
        </el-col>
        </el-row>
        <el-divider content-position="right">
            <div class="right">
                <el-button type="primary" icon="el-icon-search" @click="getData()" size="small" >查詢</el-button>
            </div>  
        </el-divider>
        <el-row class="mb-10">
            <el-table v-loading="loading" element-loading-text="請求資料中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" 
                :header-cell-style="{color:'#20638C'}" :data="tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" style="width: 100%;"
                :cell-style="{padding: '0', height: '40px'}" >
                <el-table-column align="center" prop="recordedOn" label="日期" sortable :show-overflow-tooltip="false" fixed width="95px" />
                <el-table-column align="center" prop="_volume" label="估算用水量(度)" sortable :show-overflow-tooltip="true" />
                <el-table-column align="center" prop="_compareToYesterday" :label="compareToYesterdayLabel" sortable :show-overflow-tooltip="true" >
                    <template slot-scope="scope">
                            <el-tag v-if="!isEmptyButZero(scope.row._compareToYesterday)" :type="scope.row._compareToYesterday >0 ? 'success' : scope.row._compareToYesterday < 0 ? 'danger' : 'info'" disable-transitions>
                                <div v-show="scope.row._compareToYesterday > 0">
                                    {{scope.row._compareToYesterday}}%<i class="el-icon-top" />
                                </div>
                                <div v-show="scope.row._compareToYesterday == 0">
                                    {{scope.row._compareToYesterday}}%
                                </div>
                                <div v-show="scope.row._compareToYesterday < 0">
                                    {{scope.row._compareToYesterday}}%<i class="el-icon-bottom" />
                                </div>
                            </el-tag>
                    </template>
                </el-table-column>
                <el-table-column  align="center" prop="_note" label="用水記事" :show-overflow-tooltip="true"/>
                <el-table-column  align="center" label="操作" :show-overflow-tooltip="true" width="350px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" icon="el-icon-edit" @click="edit(scope.row)" >編輯</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <el-col>    
                <el-pagination background layout="sizes, prev, pager, next" 
                    :total="this.tableData.length" @current-change="setPage" @size-change="changePages" :page-sizes="page_size_options"/>
            </el-col>
        </el-row> 

        <el-dialog :title="dialogData.title" :visible.sync="dialogData.show" width="50%" center :close-on-click-modal="false">
            <el-form :model="dialogData.data" size="medium" ref="rForm" status-icon>
                <h3>{{dialogData.data.recordedOn}} 用水記事:</h3>
                <el-form-item label="">
                    <el-input type="textarea" v-model="dialogData.data.note"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="dialogData.show = false" size="mini">取消</el-button>
                <el-button type="primary" @click="Submit()" size="mini">完成</el-button>
            </div>
        </el-dialog>

    </div>
</template> 

<script>
import _ from 'lodash'
import {viewRuleSetting} from '@/components/common'

export default {
    name: 'UseNote',
    components: {
        
    },

    data() {
        return {
            loading: false,
            dateRange: "",
            waterId: "",
            tableData: [],
            currentPage: 1, 
            pageSize: 30,
            page_size_options: [30, 60, 90, 120, 150, 180],
            dialogData: {
                show: false,
                title: "編輯",
                data: {
                    note: "",
                },
            },
            compareToYesterdayLabel: '較前一日增減',
        }
    },
    watch:
    {

    },
    computed:
    {
        currentWaterId()
        {
            return JSON.parse(localStorage.getItem('currentProfile')).waterId
        }
    },
    async created()
    {
        this.dateRange = this.$moment().local().format("YYYY-MM")
        await this.getData()
    },
    mounted() {
        this.getTimeUnitValue()
    },
    methods:
    {
        async getData()
        {
            let startOfMonth = this.$moment(this.dateRange).startOf('month').format('YYYY-MM-DD')
            let endOfMonth   = this.$moment(this.dateRange).endOf('month').format('YYYY-MM-DD')
            // console.log(startOfMonth)
            // console.log(endOfMonth)
            let url = "/api/report/profile/" + this.currentWaterId + "/dailyRawdata?start=" + startOfMonth + "&end=" + endOfMonth
            this.loading = true
            this.axios.get(url).then( res =>
            {
                // console.log(res.data)
                if(_.isArray(res.data))
                {
                    _.forEach( res.data, e =>
                    {
                        // 當天以後的資料不顯示(包含當天),20230608
                        if(e["recordedOn"] && this.$moment(e["recordedOn"]).isSameOrAfter(this.$moment(), 'day')) {
                            e["_compareToYesterday"] = ''
                            e["_volume"] = ''
                        } else {
                            e["_compareToYesterday"] = Math.round(e["compareToYesterday"] * 10000) / 100
                            e["_volume"] = (Math.round(e["volume"] * 10000) / 10000).toFixed(2)
                        }
                        e["_note"] = e["note"]
                    })
                    let tp = []
                    for (let m = this.$moment(startOfMonth); m <= this.$moment(endOfMonth); m.add(1, 'days'))
                    {
                        let r = _.find(res.data, {"recordedOn": m.format('YYYY-MM-DD')})
                        r ? tp.push(r) : tp.push({"recordedOn": m.format('YYYY-MM-DD'), "note": null})
                    }
                    this.tableData = tp
                }
                else
                {
                    this.$message({ message: '無法擷取資料!', type: 'warning' }) 
                }
            })
            .catch( err =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
                console.error(err)
            })
            .finally( () => {
                this.loading = false
            })
        },
        edit(row)
        {
            this.dialogData.show = true
            this.dialogData.data = row
        },
        Submit()
        {
            this.$confirm('確認提交?', '注意',
            {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
            })
            .then( async () => 
            {
                await this.axios.put('/api/report/profile/' + this.currentWaterId + '/note?recordedOn=' + this.dialogData.data.recordedOn + '&note=' + this.dialogData.data.note  ).then( res =>
                {
                    let response = res.data
                    if (response.code == 200)
                    {
                        this.$message({ showClose: true,  message: "編輯成功", type: 'success' })
                    }
                    else
                    {
                        this.$message({ showClose: true,  message: response.reason,  type: 'error' })
                    } 

                })
                .catch( () =>
                {
                    this.$message({  showClose: true, message: '編輯失敗', type: 'error' })
                })

                // 編輯資料後重新查詢,20230608
                await this.getData()
            })
            .catch( () =>
            {

            })
            .finally( async () =>
            {
                this.dialogData.show = false
            })
        },
        setPage(page)
        {
            this.currentPage = page
        },
        changePages(page)
        {
            this.pageSize = page
        },
        isEmptyButZero(value) {
            return value === '' || value === null || value === undefined
        },
        async getTimeUnitValue() {
            this.settingData = await viewRuleSetting()
            console.log('this.settingData ->' + this.settingData )
            this.volumeViewTimeUnit = this.settingData.volumeViewTimeUnit

            switch (this.volumeViewTimeUnit) {
                case 'week':
                    this.compareToYesterdayLabel = '較前一週增減'
                    break;
                case 'month':
                    this.compareToYesterdayLabel = '較前一月增減'
                    break;
                case 'year':
                    this.compareToYesterdayLabel = '較前一年增減'
                    break;
                default:
                    this.compareToYesterdayLabel = '較前一日增減'
                    break;
            }
            
        },
    }
}
</script>
